module.exports = __webpack_public_path__ + "od-info-circle-yellow-icon/od-info-circle-yellow-icon-5590a80135279f4002fbc799985e5712.svg";